<template>
    <v-container fluid>
        <v-data-table
                class="gpu-table"
                dense
                :headers="headers"
                :items="items"
                item-key="id"
                :search="search"
        >
            <template v-slot:body.prepend>
                <tr>
                    <td>
                        <v-combobox
                                v-model="filter.status"
                                :items="[{text: 'Working', value: 1}, { text: 'Service', value: 0}]"
                                clearable
                        ></v-combobox>
                    </td>
                    <td>
                        <v-text-field v-model="filter.serial_number" type="text"></v-text-field>
                    </td>
                    <td>
                    </td>
                    <td>
                        <v-combobox
                                v-model="filter.computer"
                                :items="computers"
                                itemValue="id"
                                itemText="code"
                                clearable
                        ></v-combobox>
                    </td>
                </tr>
            </template>

            <template v-slot:item.computer_id="{ item }">
                {{ computerById(item.computer_id).code }}
            </template>

            <template v-slot:item.component_id="{ item }">
                {{ cardById(item.component_id).code }}
            </template>
            <template v-slot:item.status="{ item }">
                <service-switch v-bind="item"></service-switch>
            </template>

        </v-data-table>
    </v-container>
</template>

<script>
    import {mapGetters} from "vuex";
    import ServiceSwitch from "./ServiceSwitch";

    export default {
        components: {
            ServiceSwitch
        },
        data() {
            return {
                polling: null,
                search: "",
                serial_number: "",
                filter: {
                    serial_number: '',
                    computer: '',
                    status: null,
                },
                headers: [
                    // {
                    //     text: 'Id',
                    //     value: 'id',
                    // },
                    {
                        text: 'Status',
                        value: 'status',
                        filter: f => {
                            return this.filter.status ? Number(f) === Number(this.filter.status.value) : true;
                        }
                    },
                    {
                        text: 'Serial',
                        value: 'serial_number',
                        filter: f => {
                            return (f + '').toLowerCase().includes(this.filter.serial_number.toLowerCase())
                        }
                    },
                    {
                        text: 'Component',
                        value: 'component_id',
                    },
                    {
                        text: 'Rig',
                        value: 'computer_id',
                        filter: f => {
                            return this.filter.computer ? parseInt(f) === parseInt(this.filter.computer.id) : true;
                        }
                    },
                ],
            }
        },
        computed: {
            ...mapGetters('gpus', {
                items: 'list',
            }),
            ...mapGetters('computers', {
                computerById: 'byId',
            }),
            ...mapGetters('cards', {
                cardById: 'byId',
            }),
            computers() {
                return this.$store.state.computers.items;
            },
            // statuses() {
            //     return this.$store.state.gpus.statuses;
            // }
            // ...mapState({
            //     computers: state => state.computers.items,
            // }),
        },
        beforeDestroy() {
        },
        created() {
        }
    }
</script>

<style>

    .gpu-table .v-input--selection-controls {
        margin-top: 0;
        padding: 4px 0 2px;
    }

</style>
